.form {
    align-items: center;
    border-bottom: 1px solid var(--black);
    display: flex;
    justify-content: space-between;

    & label {
        flex: 1;
    }
}

.input {
    background: transparent;
    border: none;
    color: var(--black);
    font: var(--font-p-16);
    outline: none;
    width: 100%;

    &::placeholder {
        color: var(--gray-500);
    }
}

.submit {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}

.searchIcon {
    width: 24px;
    height: 24px;
    fill: var(--black);
}
